import inputMask from './inputformatters';

const sortByAlphabetical = () => <JQuery<HTMLElement>>$('#sortButtonByAlphabetical');
const sortByAlphabeticalDesc = () => <JQuery<HTMLElement>>$('#sortButtonByAlphabeticalDesc');
const sortByNewest = () => <JQuery<HTMLElement>>$('#sortButtonByNewest');
const sortByOldest = () => <JQuery<HTMLElement>>$('#sortButtonByOldest');
const coverSpin = () => <JQuery<HTMLDivElement>>$('#cover-spin');
const hfMissingPersonsCount = () => <JQuery<HTMLInputElement>>$("#hfMissingPersonsCount");
const spnResultsCount = () => <JQuery<HTMLSpanElement>>$('#spnResultsCount');

function init() {
	inputMask.init();
	$('#frmMissingPersonSearch').submit(function (event) {
		showSpinner();
		event.preventDefault();
		var form = $(this);
		$.ajax({
			type: form.attr('method'),
			url: form.attr('action'),
			data: form.serializeArray(),
			success: function (data)
			{		
				$("#missingPersons").html(data);
				updateResultsCount();
				hideSpinner();
			},
			error: function (req, status, error) {
				console.log("error occured");
				hideSpinner();
			}			
		});
	});

	sortByAlphabetical().on('click', () => sortMissingPersonsBy("name_asc"));
	sortByAlphabeticalDesc().on('click', () => sortMissingPersonsBy("name_desc"));
	sortByNewest().on('click', () => sortMissingPersonsBy("missing_desc"));
	sortByOldest().on('click', () => sortMissingPersonsBy("missing_asc"));
	updateResultsCount();
}

function updateResultsCount() {
	let count = hfMissingPersonsCount().val();
	let targetSpan = spnResultsCount();

	if (count && targetSpan) {
		targetSpan.text(`Results count: ${count}`);
	}
}

// Sets seareched order and submits form.
function sortMissingPersonsBy(sort) {
	if (sort) {
		$("#SearchedSortOrder").val(sort.toString());
		$('#frmMissingPersonSearch').submit();
	}
}

// Function to show the spinner
function showSpinner() {
	coverSpin().show();
}


// Function to hide the spinner
function hideSpinner() {	
	coverSpin().hide();
}


$(init);